export const NominalSizes = [
    { value: 0.25, label: "1/4\" (DN6)" },
    { value: 0.3125, label: "5/16\" (DN8)" },
    { value: 0.375, label: "3/8\" (DN10)" },
    { value: 0.5, label: "1/2\" (DN12)" },
    { value: 0.625, label: "5/8\" (DN16)" },
    { value: 0.75, label: "3/4\" (DN20)" },
    { value: 1, label: "1\" (DN25)" },
    { value: 1.25, label: "1-1/4\" (DN32)" },
    { value: 1.5, label: "1-1/2\" (DN40)" },
    { value: 2, label: "2\" (DN50)" },
    { value: 2.5, label: "2-1/2\" (DN65)" },
    { value: 3, label: "3\" (DN80)" },
    { value: 3.5, label: "3-1/2\" (DN90)" },
    { value: 4, label: "4\" (DN100)" },
    { value: 5, label: "5\" (DN125)" },
    { value: 6, label: "6\" (DN150)" },
    { value: 8, label: "8\" (DN200)" },
    { value: 10, label: "10\" (DN250)" },
    { value: 12, label: "12\" (DN300)" },
    { value: 14, label: "14\" (DN350)" },
    { value: 16, label: "16\" (DN400)" },
    { value: 18, label: "18\" (DN450)" },
    { value: 20, label: "20\" (DN500)" },
    { value: 22, label: "22\" (DN550)" },
    { value: 24, label: "24\" (DN600)" },

]

export const TempMeasurement = [
    { value: 'fahrenheit', label: "°F" },
    { value: 'celcius', label: "°C" },

]

export const PressureMeasurement = [
    { value: 'psi', label: "PSI" },
    { value: 'bar', label: "Bar" },

]

export const Movement = [
    { value: 'no-oscillations-slight-slow-movement', label: "No oscillations; slight, slow movement" },
    { value: 'oscillations-frequent-uniform-movement', label: "Oscillations; frequent uniform movement" },
    { value: 'strong-vibrations-rhythmical-and-intermittent-movement', label: "Strong vibrations; intermittent movement" },

]

export const FlowCondition = [
    { value: 'stationary-or-slow-and-uniform-flow', label: "Stationary or slow and uniform flow" },
    { value: 'pulsating-and-unsteady-flow', label: "Pulsating and unsteady flow" },
    { value: 'rhythmical-and-intermittent-flow', label: "Rhythmical and intermittent flow" },

]

export const Application = [
    { value: 'static', label: "Static" },
    { value: 'dynamic', label: "Dynamic" },


]



// export const Alloy = [
//     { value: '321', label: "321 Stainless Steel" },
//     { value: '316', label: "316 Stainless Steel" },
//     { value: '304', label: "304 Stainless Steel" },
//     { value: 'inconel', label: "Inconel" },
//     { value: 'monel', label: "Monel" },
//     { value: 'bronze', label: "Bronze" },
// ]


export const HoseAlloy = [
    { value: '321', label: "321 Stainless Steel", braidalloy: [{ value: '316', label: "316 Stainless Steel" }, { value: '304', label: "304 Stainless Steel" }] },
    { value: '316', label: "316 Stainless Steel", braidalloy: [{ value: '316', label: "316 Stainless Steel" }, { value: '304', label: "304 Stainless Steel" } ]}, 
    { value: '304', label: "304 Stainless Steel", braidalloy: [{ value: '304', label: "304 Stainless Steel" }] },
    { value: 'Inconel', label: "Inconel™️ 625", braidalloy: [{ value: 'Inconel', label: "Inconel™️ 625" }] },
    { value: 'Monel', label: "Monel™️ 400", braidalloy: [{ value: 'Monel', label: "Monel™️ 400" }] },
    { value: 'Bronze', label: "Bronze", braidalloy: [{ value: 'Bronze', label: "Bronze" }] },
    { value: 'Hastelloy', label: "Hastelloy™️ C-276", braidalloy: [{ value: 'Hastelloy', label: "Hastelloy™️ C-276" }] },
]

export const BraidAlloy = [
    { value: '321', label: "321 Stainless Steel", braidalloy: [{ value: '316', label: "316 Stainless Steel" }, { value: '304', label: "304 Stainless Steel" }] },
    { value: '316', label: "316 Stainless Steel", braidalloy: [{ value: '316', label: "316 Stainless Steel" }, { value: '304', label: "304 Stainless Steel" } ]}, 
    { value: '304', label: "304 Stainless Steel", braidalloy: [{ value: '316', label: "316 Stainless Steel" }, { value: '304', label: "304 Stainless Steel" }] },
    { value: 'Inconel', label: "Inconel™️ 625", braidalloy: [{ value: 'Inconel', label: "Inconel™️ 625" }] },
    { value: 'Monel', label: "Monel™️ 400", braidalloy: [{ value: 'Monel', label: "Monel™️ 400" }] },
    { value: 'Bronze', label: "Bronze", braidalloy: [{ value: 'Bronze', label: "Bronze" }] },
    { value: 'Hastelloy', label: "Hastelloy™️ C-276", braidalloy: [{ value: 'Hastelloy', label: "Hastelloy™️ C-276" }] },
]


export const HoseFilter = [
    { value: '321', hosealloy: ['P3','P4','700','800','900','1400','400','P5'] },
    { value: '316', hosealloy: ['P3','P4','700','800','900','1400','400','P5'] },
   { value: '304', hosealloy: ['P3','P4','700','800','900','1400','400','P5'] },
    { value: 'Inconel', hosealloy: ['625'] },
    { value: 'Monel', hosealloy: ['740'] },
    { value: 'Bronze', hosealloy: ['794'] },
    { value: 'Hastelloy', hosealloy: ['776'] },
]

export const BraidFilter = [
    { value: '316', braidalloy: ['P3','P4','700','800','900','1400','400'] },
   { value: '304', braidalloy: ['P3','P4','700','800','900','1400','400','P5'] },
   { value: 'Inconel', braidalloy: ['625'] },
   { value: 'Monel', braidalloy: ['740'] },
   { value: 'Bronze', braidalloy: ['794'] },
   { value: 'Hastelloy', braidalloy: ['776'] },
]

export const LengthMeasurement = [
    { value: 'in', label: "in" },
    { value: 'mm', label: "mm" },
    { value: 'ft', label: "ft" },
]

export const LeftFittings = [
    { value: '/images/Configuration Tool/Left Side/Raised Face Slip on Flange-L.png?150', label: "150# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Left Side/Raised Face Slip on Flange-L.png?300', label: "300# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Left Side/600 lb RF SOF w pipe spacer Left.png', label: "600# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Left Side/Raised Face Weld Neck Flange-L.png?150', label: "150# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Left Side/Raised Face Weld Neck Flange-L.png?300', label: "300# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Left Side/Raised Face Weld Neck Flange-L.png?600', label: "600# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Left Side/150 Drilling Plate Flange Left.png?150', label: "150# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Left Side/150 Drilling Plate Flange Left.png?300', label: "300# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Left Side/Lap Joint Flange on Type A Stub End-L.png?mss150', label: "MSS Type A Stub End with 150# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Left Side/Lap Joint Flange on Type A Stub End-L.png?mss300', label: "MSS Type A Stub End with 300# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Left Side/Lap Joint Flange on Type A Stub End-L.png?asa600', label: "ASA Type A Stub End with 600# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Left Side/Raised Face Slip on Flange on Type C Stub End-L.png', label: "MSS Type C Stub End with 150# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Left Side/150 Drilling Plate Flanges w Type C Stub Left.png', label: "MSS Type C Stub End with 150# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Left Side/Female JIC Swivel-L.png', label: "Female JIC" },
    { value: '/images/Configuration Tool/Left Side/Female Coupling-L.png', label: "Female Pipe Coupling" },
    { value: '/images/Configuration Tool/Left Side/Female Union-L.png', label: "Female Union" },
    { value: '/images/Configuration Tool/Left Side/Hex Male NPT-L.png', label: "Hex Male Nipple" },
    { value: '/images/Configuration Tool/Left Side/Male NPT-L.png', label: "Pipe Nipple" },
    { value: '/images/Configuration Tool/Left Side/Weld Nipple-L.png', label: "Weld Nipple" },
    { value: '/images/Configuration Tool/Left Side/45 Deg Elbows LR Left-Up.png', label: "45 Degree Elbow (Facing Up)" },
    { value: '/images/Configuration Tool/Left Side/45 Deg Elbows LR Left-Down.png', label: "45 Degree Elbow (Facing Down)" },
    { value: '/images/Configuration Tool/Left Side/90 Deg Elbows LR Left-Up.png', label: "90 Degree Elbow Long Radius (Facing Up)" },
    { value: '/images/Configuration Tool/Left Side/90 Deg Elbows LR Left-Down.png', label: "90 Degree Elbow Long Radius (Facing Down)" },
    { value: '/images/Configuration Tool/Left Side/90 Deg Elbows SR Left-Up.png', label: "90 Degree Elbow Short Radius (Facing Up)" },
    { value: '/images/Configuration Tool/Left Side/90 Deg Elbows SR Left-Down.png', label: "90 Degree Elbow Short Radius (Facing Down)" },
    { value: '/images/Configuration Tool/Left Side/Sanitary Fittings I-Line Medium-Left.png', label: "Sanitary Fitting I-Line Medium" },
    { value: '/images/Configuration Tool/Left Side/Sanitary Fittings I-Line Short-Left.png', label: "Sanitary Fitting I-Line Short" },
    { value: '/images/Configuration Tool/Left Side/Vict-Groove Left.png', label: "Victaulic/Grooved End" },
]

export const RightFittings = [
    { value: '/images/Configuration Tool/Right Side/Raised Face Slip on Flange-R.png?150', label: "150# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Right Side/Raised Face Slip on Flange-R.png?300', label: "300# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Right Side/600 lb RF SOF w pipe spacer Right.png', label: "600# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Right Side/Raised Face Weld Neck Flange-R.png?150', label: "150# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Right Side/Raised Face Weld Neck Flange-R.png?300', label: "300# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Right Side/Raised Face Weld Neck Flange-R.png?600', label: "600# Raised Face Weld Neck Flange" },
    { value: '/images/Configuration Tool/Right Side/150 Drilling Plate Flange Right.png?150', label: "150# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Right Side/150 Drilling Plate Flange Right.png?300', label: "300# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Right Side/Lap Joint Flange on Type A Stub End-R.png?mss150', label: "MSS Type A Stub End with 150# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Right Side/Lap Joint Flange on Type A Stub End-R.png?mss300', label: "MSS Type A Stub End with 300# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Right Side/Lap Joint Flange on Type A Stub End-R.png?asa600', label: "ASA Type A Stub End with 600# Lap Joint Flange" },
    { value: '/images/Configuration Tool/Right Side/Raised Face Slip on Flange on Type C Stub End-R.png', label: "MSS Type C Stub End with 150# Raised Face Slip-On Flange" },
    { value: '/images/Configuration Tool/Right Side/150 Drilling Plate Flanges w Type C Stub Right.png', label: "MSS Type C Stub End with 150# Drilling Plate Flange" },
    { value: '/images/Configuration Tool/Right Side/Female JIC Swivel-R.png', label: "Female JIC" },
    { value: '/images/Configuration Tool/Right Side/Female Coupling-R.png', label: "Female Pipe Coupling" },
    { value: '/images/Configuration Tool/Right Side/Female Union-R.png', label: "Female Union" },
    { value: '/images/Configuration Tool/Right Side/Hex Male NPT-R.png', label: "Hex Male Nipple" },
    { value: '/images/Configuration Tool/Right Side/Male NPT-R.png', label: "Pipe Nipple" },
    { value: '/images/Configuration Tool/Right Side/Weld Nipple-R.png', label: "Weld Nipple" },
    { value: '/images/Configuration Tool/Right Side/45 Deg Elbows LR Right-Up.png', label: "45 Degree Elbow (Facing Up)" },
    { value: '/images/Configuration Tool/Right Side/45 Deg Elbows LR Right-Down.png', label: "45 Degree Elbow (Facing Down)" },
    { value: '/images/Configuration Tool/Right Side/90 Deg Elbows LR Right-Up.png', label: "90 Degree Elbow Long Radius (Facing Up)" },
    { value: '/images/Configuration Tool/Right Side/90 Deg Elbows LR Right-Down.png', label: "90 Degree Elbow Long Radius (Facing Down)" },
    { value: '/images/Configuration Tool/Right Side/90 Deg Elbows SR Right-Up.png', label: "90 Degree Elbow Short Radius (Facing Up)" },
    { value: '/images/Configuration Tool/Right Side/90 Deg Elbows SR Right-Down.png', label: "90 Degree Elbow Short Radius (Facing Down)" },
    { value: '/images/Configuration Tool/Right Side/Sanitary Fittings I-Line Medium-Right.png', label: "Sanitary Fitting I-Line Medium" },
    { value: '/images/Configuration Tool/Right Side/Sanitary Fittings I-Line Short-Right.png', label: "Sanitary Fitting I-Line Short" },
    { value: '/images/Configuration Tool/Right Side/Vict-Groove Right.png', label: "Victaulic/Grooved End" },
]

// The flange on these fittings floats on the stub end and never touches the media,
// so it can be a different (usually cheaper) alloy than the welded-on stub end.
export const FloatingFlangeFittings = [
    "MSS Type A Stub End with 150# Lap Joint Flange",
    "MSS Type A Stub End with 300# Lap Joint Flange",
    "ASA Type A Stub End with 600# Lap Joint Flange",
    "MSS Type C Stub End with 150# Raised Face Slip-On Flange",
    "MSS Type C Stub End with 150# Drilling Plate Flange",
]

export const FittingAlloys = [
    { value: '321 Stainless Steel', label: "321 Stainless Steel" },
    { value: '316 Stainless Steel', label: "316 Stainless Steel" },
    { value: '304 Stainless Steel', label: "304 Stainless Steel" },
    { value: 'Inconel', label: "Inconel™️ 625" },
    { value: 'Monel', label: "Monel™️ 400" },
    { value: 'Bronze', label: "Bronze" },
    { value: 'Hastelloy', label: "Hastelloy™️ C-276" },
      { value: 'Carbon Steel', label: "Carbon Steel" },

 

]